/**
 * DataTable - styled data table wrapper.
 * Custom element: <data-table>
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import { ThemeComponent } from "./theme.js";
import "./vendor.js";
class DataTable extends ThemeComponent {}
setFunctionName(DataTable, "DataTable");
const propertyTypes = {};
DataTable.prototype.$name = "DataTable";
DataTable.prototype.$info = JSON.parse('{"name":"DataTable","meta":{"isLegacy":false,"selector":"data-table"},"props":[],"refs":[]}');
DataTable.prototype.$info.component = DataTable;
for (const prop of DataTable.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("DataTable/DataTable.ts", {
  DataTable: DataTable
}, void 0);